import { ReactComponent as TrashIcon } from "../../../assets/svg/icons/trash.svg";

export type RemoveButtonV2Props = {
  label?: string;
  onClick: () => void;
};

export function RemoveButtonV2({ label, onClick }: RemoveButtonV2Props) {
  return (
    <button className="ov2-remove-button" type="button" onClick={onClick} aria-label={label} title={label}>
      <TrashIcon />
      <span>{label}</span>
    </button>
  );
}
